import { isAllUpperCaseLetters } from '~/cynqueModules/utils/isAllUpperCaseLetters'

/**
 * Derive the app's entity name (e.g. 'company', 'teamMember', 'tsd') from a
 * route name's first `-`-segment. Pure logic shared by the
 * `$getEntityNameFromRoute` plugin (globalProperty, used in components) and the
 * Nuxt-2-context shim in cynqueModules/nuxtRuntime.ts (used in asyncData).
 *
 * Nuxt 4 route names are the Nuxt-3 hyphenated form (e.g.
 * `Companies-Overview-Sales-id`), so the first segment is the plural entity
 * root just as it was under Bridge.
 */
export function getEntityNameFromRoute(
  routeName: string | null | undefined
): string | null {
  const fn = ['cynqueModules/getEntityNameFromRoute]']
  const nameRoot = routeName?.toString().split('-')[0]
  if (!nameRoot) {
    // eslint-disable-next-line no-console
    console.warn(`${fn} Route name '${routeName}' has no name root.`)
    return null
  }
  let entityName
  // if nameRoot is -not- plural entity name,
  // need to add special case in if block below
  if (nameRoot === 'Home') {
    entityName = 'teamMember'
  } else {
    entityName = nameRoot
    entityName = entityName.replaceAll('%20', '')
    entityName = entityName.replaceAll(' ', '')
    entityName = entityName.replace(/ies$/, 'y')
    entityName = entityName.replace(/s$/, '')
    entityName = isAllUpperCaseLetters(entityName)
      ? entityName.toLowerCase()
      : entityName.charAt(0).toLowerCase() + entityName.slice(1)
    entityName = entityName.replace('tSD', 'tsd')
  }

  // eslint-disable-next-line no-console
  console.debug(`${fn} Returning entityName = '${entityName}'`)
  return entityName
}
